// extracted by mini-css-extract-plugin
export default {"newCommentBox":"newComment_newCommentBox__7KG-i"};